import { UserRole } from '../../../enums/userEnums';
import styles from './AccessBadge.module.scss';

const ROLE_STYLE: Record<UserRole, 'green' | 'blue' | 'red'> = {
  [UserRole.VIEWER]: 'green',
  [UserRole.EDITOR]: 'blue',
  [UserRole.ADMIN]: 'red',
  [UserRole.CES_ADMIN]: 'red',
};

interface AccessBadgeProps {
  role: UserRole;
}

const AccessBadge = ({ role }: AccessBadgeProps) => <span className={`${styles.badge} ${styles[ROLE_STYLE[role]]}`}>{role}</span>;

export default AccessBadge;
